var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "#676C77",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99979 7.99979C7.76614 8.00024 7.5397 7.91887 7.35979 7.76979L1.35979 2.76979C1.15557 2.60005 1.02715 2.35614 1.00277 2.09171C0.978387 1.82728 1.06005 1.564 1.22979 1.35979C1.39953 1.15557 1.64344 1.02715 1.90786 1.00277C2.17229 0.978387 2.43557 1.06005 2.63979 1.22979L7.99979 5.70979L13.3598 1.38979C13.4621 1.30672 13.5798 1.24469 13.7061 1.20726C13.8324 1.16983 13.9649 1.15773 14.096 1.17167C14.227 1.18561 14.354 1.22531 14.4696 1.28848C14.5853 1.35166 14.6873 1.43706 14.7698 1.53979C14.8614 1.64261 14.9307 1.76324 14.9735 1.89411C15.0163 2.02498 15.0316 2.16328 15.0185 2.30035C15.0053 2.43741 14.964 2.57028 14.8971 2.69064C14.8303 2.811 14.7392 2.91624 14.6298 2.99979L8.62979 7.82979C8.4447 7.9553 8.22289 8.01516 7.99979 7.99979Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.8e198d9bf29e16737c2d4d75c1265c61.svg";
export { ForwardRef as ReactComponent };